import React from 'react';

import { isDesktopApp } from '@/api/desktopSync';
import {
  localStoreNeedsAdministratorRecovery,
  localStoreRecoveryDetail,
} from '@/utils/localStoreRecovery';


export default function DesktopLocalStoreNotice() {
  if (!isDesktopApp()) return null;
  const desktop = window.lvbDesktop;
  const status = desktop?.localStoreStatus;
  const bootstrapStatusUnknown = desktop?.deviceStatus?.status === 'unknown'
    || status?.reason === 'status_unavailable'
    || desktop?.localRuntimeStatus?.reason === 'status_unavailable'
    || desktop?.localStoreRecoveryStatus?.reason === 'status_unavailable';
  if (bootstrapStatusUnknown) {
    return (
      <div className="px-3 py-2 bg-red-800 text-white text-xs font-medium flex-shrink-0" data-testid="desktop-bootstrap-status-notice">
        This computer&apos;s protected offline status could not be verified. Do not rely on offline work; restart the desktop app or contact an administrator.
      </div>
    );
  }
  if (status?.state !== 'unavailable') return null;
  const rebuildRequired = localStoreNeedsAdministratorRecovery(status);

  return (
    <div
      className="px-3 py-2 bg-red-800 text-white text-xs font-medium flex-shrink-0"
      data-testid="desktop-local-store-notice"
    >
      {localStoreRecoveryDetail(status)}{' '}
      {rebuildRequired
        ? 'An administrator can review recovery in Settings → Devices.'
        : 'Retry from Settings → Devices or restart the desktop app.'}
    </div>
  );
}
